import React, { useEffect, useState } from 'react';
import { ReactComponent as HomeLine } from '../../assets/svg/sideBottomBar/home-line.svg';
import { ReactComponent as AboutUser } from '../../assets/svg/sideBottomBar/about-user.svg';
import { ReactComponent as Portfolio } from '../../assets/svg/sideBottomBar/portfolio-layer.svg';
import { ReactComponent as Skills } from '../../assets/svg/sideBottomBar/skills.svg';
import { ReactComponent as Qualification } from '../../assets/svg/sideBottomBar/qualification.svg';

const navItems = [
   { id: 'profile', name: 'Home', icon: HomeLine },
   { id: 'about', name: 'About', icon: AboutUser },
   { id: 'experience', name: 'Experience', icon: Portfolio },
   { id: 'projects', name: 'Projects', icon: Portfolio },
   { id: 'skills', name: 'Skills', icon: Skills },
   { id: 'qualification', name: 'Education', icon: Qualification },
];

const SideBottomBar = () => {
   const [active, setActive] = useState('profile');

   useEffect(() => {
      const sections = navItems
         .map((n) => document.getElementById(n.id))
         .filter(Boolean);
      const obs = new IntersectionObserver(
         (entries) => {
            entries.forEach((e) => {
               if (e.isIntersecting) setActive(e.target.id);
            });
         },
         { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
      );
      sections.forEach((s) => obs.observe(s));
      return () => obs.disconnect();
   }, []);

   return (
      <>
         {/* Desktop sidebar */}
         <nav className="hidden md:flex fixed left-5 top-1/2 -translate-y-1/2 z-30 flex-col gap-1.5 rounded-2xl border border-zinc-200/70 dark:border-zinc-800/80 bg-white/70 dark:bg-zinc-900/60 backdrop-blur-md p-2 shadow-soft">
            {navItems.map(({ id, name, icon: Icon }) => {
               const isActive = active === id;
               return (
                  <a
                     key={id}
                     href={`#${id}`}
                     onClick={() => setActive(id)}
                     aria-label={name}
                     className={`group relative flex h-10 w-10 items-center justify-center rounded-xl transition-all ${
                        isActive
                           ? 'bg-brand-500/15 text-brand-600 dark:text-brand-400 ring-1 ring-brand-500/30'
                           : 'text-zinc-500 hover:text-zinc-900 dark:hover:text-white hover:bg-zinc-100 dark:hover:bg-zinc-800'
                     }`}
                  >
                     <Icon className="h-5 w-5 fill-current" />
                     <span className="pointer-events-none absolute left-12 whitespace-nowrap rounded-md bg-zinc-900 dark:bg-zinc-100 dark:text-zinc-900 px-2 py-1 text-[11px] font-semibold text-white opacity-0 -translate-x-2 transition-all group-hover:opacity-100 group-hover:translate-x-0">
                        {name}
                     </span>
                  </a>
               );
            })}
         </nav>

         {/* Mobile bottom dock */}
         <nav className="md:hidden fixed inset-x-3 bottom-3 z-30 flex items-center justify-around gap-1 rounded-2xl border border-zinc-200/70 dark:border-zinc-800/80 bg-white/80 dark:bg-zinc-900/70 backdrop-blur-md p-1.5 shadow-soft">
            {navItems.map(({ id, name, icon: Icon }) => {
               const isActive = active === id;
               return (
                  <a
                     key={id}
                     href={`#${id}`}
                     onClick={() => setActive(id)}
                     aria-label={name}
                     className={`flex flex-1 flex-col items-center justify-center gap-0.5 rounded-xl py-1.5 transition-all ${
                        isActive
                           ? 'bg-brand-500/15 text-brand-600 dark:text-brand-400'
                           : 'text-zinc-500'
                     }`}
                  >
                     <Icon className="h-5 w-5 fill-current" />
                     <span className="text-[9.5px] font-semibold tracking-wide">{name}</span>
                  </a>
               );
            })}
         </nav>
      </>
   );
};

export default SideBottomBar;
